<template>
  <div>
    <div class="card shadow">
      <div class="card-header bg-transparent">
        <div>
          <h3 class="mb-0">
            {{ $t('message.medicalFiles') }}
          </h3>
        </div>
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col-lg-4" v-if="hasAssistante || hasPraticienRole || hasMedecinControleRole">
              <router-link :to="{ name: 'medical-management' }">
                  <stats-card
                          :title="$tc('message.gestionmedical', 2)"
                          type="gradient-pink"
                          icon="fas fa-link"
                          class="mb-4"
                  ></stats-card>
              </router-link>
          </div>
          <div class="col-lg-4" v-if="hasSouscripteurRole">
              <router-link :to="{ name: 'mesAffilies' }">
                  <stats-card
                          :title="$tc('message.mesAffilie', 2)"
                          type="gradient-pink"
                          icon="fas fa-link"
                          class="mb-4"
                  ></stats-card>
              </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import i18n from "@/plugins/i18n";
import _ from 'lodash';

export default {
  name: "UserManagement",
  computed: {
    ...mapGetters([
      'groupeActivites',
      'hasAdminRole',
      'hasMedecinControleRole',
      'hasAssistante',
      'hasPatientRole',
      'hasPraticienRole',
      'hasSouscripteurRole',
      'hasGestionnaireRole']),

    can:function () {
      return this.hasAdminRole || this.hasGestionnaireRole || this.hasAssistante;
    },

    userIsMed:function(){
      return (JSON.parse(localStorage.getItem('user')))['isMedicasure'];
    },

    mGroupeActivites:function (){
      let gArray=[];
      _.forEach(this.groupeActivites, function (activite){
        gArray.push({name: (i18n.t(`message.activite.${activite.id}`)).substr(0,65),slug:activite.slug});
      });
      return gArray;
    }
  },

  methods: {
    getGroupeActivites:function (){
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getGroupeActivites', { args : args });
    }
  },

  mounted() {
    this.getGroupeActivites();
  }


}
</script>

<style scoped>

</style>